<script setup lang="ts">
  defineSlots<{
    search(): unknown;
    quantity?(): unknown;
  }>();
</script>

<template>
  <div
    class="flex w-full items-center gap-4"
    data-testid="search-toolbar"
  >
    <div
      class="min-w-0 flex-1"
      data-testid="search-toolbar-search"
    >
      <slot name="search" />
    </div>
    <div
      v-if="$slots.quantity"
      class="w-50 shrink-0"
      data-testid="search-toolbar-quantity"
    >
      <slot name="quantity" />
    </div>
  </div>
</template>
